define('Cubix_Stone/js/diamondnonfeedrings',[
  "jquery",
  "Magento_Theme/js/handlebars.min",
  "Bootsgrid_Vfinance/js/product/finance",
], function ($, Handlebars, finance) {
  "use strict";
  $.widget("cubix.diamondfeed", {
    options: {
      shape: "",
      productpreviewapi: "",
      required_options: "",
      attributesetname: "",
      preview_xhr: "",
      timeout: 0,
      financeobj: finance(),
      metalpricecalc : "",
      productdelivery : "",
      nonfeedpricecalc : "",
      filter_keys : "",
      discount : "",
      currencysymbol : "",
      highStreetMatrix : "",
      chainShortName : "",
      metalShortName : "",
      attributeSetName : "",
      price_markup : ""
    },
    _create: function () {
      var $widget = this;
      this.getProductPrice();
      $widget._EventListener();
      $widget._checkOptionAvailability();
      this.options.financeobj = finance();
      this.handlebarsHelper();
    },
    getProductPrice: function () {
      var $widget = this;
        $.ajax({
          url: $widget.options.productfeeds,
          type: 'POST',
          dataType: 'json',
          data: {
              productId: $("input[name=product]").val(),
          },
          success: function(response) {
              $widget.options.metalpricecalc = response.metal_price;
              $widget.options.nonfeedpricecalc = response.diamond_price;
              $widget.options.filter_keys = response.filter_keys;
              $widget.options.productdelivery = response.delivery;
              $widget.options.discount = response.discount;
              $widget.options.currencysymbol = response.currency_symbol;
              $widget.options.highStreetMatrix = response.high_street_matrix;
              $widget.options.chainShortName = response.chain_short_name;
              $widget.options.metalShortName = response.metal_short_name;
              $widget.options.price_markup = response.price_markup;
              $widget.productPreview();
          },
          error: function (xhr, status, errorThrown) {
              console.log('Error happens. Try again.');
          }
      });
    },
    _EventListener: function () {
      var $widget = this;
      $(
        "input.nonfeedoption[type=hidden], input[name=selected_configurable_option],input[name=nonfeed_diamond_type]"
      ).change(function () {
        $("#selected_diamond_type").val(
          $(".nonfeed_diamond_type:checked").val()
        ); /*Used in Modifying custom price*/
        $widget._checkOptionAvailability();
        $widget.productPreview();
      });

      $(".custom-certificate input[type=radio]").change(function () {
        var diamondType = $(".nonfeed_diamond_type:checked").val();
        var selected_option_text = $(
          "label[for='" + $(this).attr("id") + "']"
        ).text();
        $("." + diamondType + "-certificate-header").text(selected_option_text);
        $widget._checkOptionAvailability();
        $widget.productPreview();
      });

      $(".custom-length input[type=radio]").change(function () {
        var selected_option_text = $(
          "label[for='" + $(this).attr("id") + "']"
        ).text();
        $(".length-header").text(selected_option_text);
        $widget.productPreview();
      });

      $(".custom-chain input[type=radio]").change(function () {
        var selected_option_text = $(
          "label[for='" + $(this).attr("id") + "']"
        ).text();
        $(".chain-header").text(selected_option_text);
        $widget._checkOptionAvailability();
        $widget.productPreview();
      });

      $(".custom-ringsize input[type=radio]").change(function () {
        var selected_option_text = $(
          "label[for='" + $(this).attr("id") + "']"
        ).text();
        $(".ringsize-header").text(selected_option_text);
        $widget._checkOptionAvailability();
        $widget.productPreview();
      });

      $(document).on("click", "#product-addtocart-button", function () {
        //temp check
        var err_msg = "";
        var productOptions = $widget.getProductOptions();

        var attributesetname = $widget.options.attributesetname;

        if (
          productOptions.ring_size == "" &&
          attributesetname == "Non Feed Rings"
        ) {
          err_msg = "Please select ring size";
        }

        if (
          productOptions.chain == "" &&
          attributesetname == "Non Feed Pendants"
        ) {
          err_msg = "Please select chain";
        }

        if (productOptions.product_id == "") {
          err_msg = "Please select metal type";
        }

        if (err_msg != "") {
          $(".cart-form-error").html(err_msg);
          return false;
        }
        //need to make more manageable
      });

      var metal_type_option = $(".metal_type_option:checked").val();
      var simple_product_id = option_product[metal_type_option];
      $("input[name=selected_configurable_option]").val(simple_product_id);
      $(document).on("change", ".metal_type_option", function () {
        metal_type_option = $(this).val();
        if (metal_type_option != "") {
          simple_product_id = option_product[metal_type_option];
          $("input[name=selected_configurable_option]").val(simple_product_id);
          var metal = $(this).data("metal");
          if ($("." + metal + "_squere.gallery_switcher").length) {
            var gallery = $("." + metal + "_squere.gallery_switcher").data(
              "gallery"
            )[1];
            if (gallery != undefined) {
              $(".diamond-product-img").attr("src", gallery.img);
            }
          }
          $widget.productPreview();
        }
      });
    },
    getProductDiamondValues: function () {
      var diamondType = $(".nonfeed_diamond_type:checked").val();
      var intensity = $("input[name='" + diamondType + "intensity']").val();
      var colour = $("input[name='" + diamondType + "colour']").val();
      
      if($.inArray(diamondType, ['yellow','ruby','sapphire']) !== -1 && colour == undefined) {
        colour = 'Very Light';
      }
      
      if($.inArray(diamondType, ['black']) !== -1 && intensity == undefined) {
        intensity = 'very light';
      }
      
      var result = {
        shape: this.options.shape,
        colour: colour,
        clarity: $("input[name='" + diamondType + "clarity']:checked").val(),
        carat: $("input[name='" + diamondType + "carat']").val(),
        cut: ($("input[name='" + diamondType + "cut']").length > 0) ? $("input[name='" + diamondType + "cut']:checked").val().toLowerCase() : 'good',
        intensity: intensity,
        lab: ($("input[name='" + diamondType + "certificate']").length > 0) ? $("input[name='" + diamondType + "certificate']:checked").val() : 'GIE',
        diamondType: diamondType,
      };
      return result;
    },
    productPreview: function () {
      $("#product_preview").css("opacity", "0.2");
      var $widget = this;
      var metalpricecalc = $widget.options.metalpricecalc;
      var nonfeedpricecalc = $widget.options.nonfeedpricecalc;
      var filter_keys = $widget.options.filter_keys;
      var productdelivery = $widget.options.productdelivery;
      var discount = $widget.options.discount;
      var currencysymbol = $widget.options.currencysymbol;
      var chainShortName = $widget.options.chainShortName;
      var metalShortName = $widget.options.metalShortName;
      var attributesetname = $widget.options.attributesetname;
      var attributesetnameformatted = attributesetname.replace(/\s/g, '');
      var price_markup_type = $widget.options.price_markup[attributesetnameformatted].type;
      var price_markup_sign = $widget.options.price_markup[attributesetnameformatted].sign;
      var price_markup_val = $widget.options.price_markup[attributesetnameformatted].val;

      if(typeof metalpricecalc !== undefined && typeof nonfeedpricecalc !== undefined) {
        var productOptions = $widget.getProductOptions();
        productOptions = $.extend(true, productOptions, $widget.getProductDiamondValues());
        if(productOptions['ring_size'] != '' && productOptions['ring_size'] != undefined) {
          var metalprice = metalpricecalc[productOptions['simple_product_id']][productOptions['ring_size']];  
        }
        else if(productOptions['bracelet_length'] != '' && productOptions['bracelet_length'] != undefined) {
          var metalprice = metalpricecalc[productOptions['simple_product_id']][productOptions['bracelet_length']];
        }
        else if(productOptions['chain'] != '' && productOptions['chain'] != undefined) {
          var metalprice = metalpricecalc[productOptions['simple_product_id']][productOptions['chain']];
        }
        else {
          var metalprice = metalpricecalc[productOptions['simple_product_id']];          
        }
        productOptions['delivery'] = productdelivery[productOptions['simple_product_id']];
        var display_final_discounted_price = 0;
        var you_save = 0;
        var diamondprice = 0;
        productOptions['cut'] = productOptions['cut'].toLowerCase();
        if(productOptions['intensity'] != '' && productOptions['intensity'] != undefined) {
          productOptions['intensity'] = productOptions['intensity'].toLowerCase();
        }
        $.each(filter_keys, function(index, keyname) {
          if(diamondprice == 0) {
            diamondprice = nonfeedpricecalc[productOptions['diamond_type']][productOptions[keyname]];
          }
          else {
            diamondprice = diamondprice[productOptions[keyname]];
          }
        });
        
        var diamond_type = productOptions['diamond_type'];
        
        $("#diamondtype-filters-" + diamond_type + " .clarity_estimated_price" ).each(function( index,obj ) {
          var clarity = $( obj ).data('clarity');
          var clarity_price = 0;
          var clarity_price_text = '';
          var keyval = '';
          $.each(filter_keys, function(index, keyname) {
            if(keyname == 'clarity') {
              keyval = clarity;
            }
            else {
              keyval = productOptions[keyname];
            }

            if(clarity_price == 0) {
              clarity_price = nonfeedpricecalc[productOptions['diamond_type']][keyval];
            }
            else {
              clarity_price = clarity_price[keyval];
            }
          });

          if(diamondprice != clarity_price) {
            clarity_price = diamondprice - clarity_price;
            if(clarity_price > 0) {
              clarity_price_text = '-' + currencysymbol + '' + clarity_price.toFixed(2);
            }
            else {
              clarity_price = Math.abs(clarity_price);
              clarity_price_text = '+' + currencysymbol + '' + clarity_price.toFixed(2);
            }
          }
          $( obj ).text(clarity_price_text);
        });

        $("#diamondtype-filters-" + diamond_type + " .cut_estimated_price" ).each(function( index,obj ) {
          var cut = $( obj ).data('cut').toLowerCase();
          var cut_price = 0;
          var cut_price_text = '';
          var keyval = '';
          $.each(filter_keys, function(index, keyname) {
            if(keyname == 'cut') {
              keyval = cut;
            }
            else {
              keyval = productOptions[keyname];
            }

            if(cut_price == 0) {
              cut_price = nonfeedpricecalc[productOptions['diamond_type']][keyval];
            }
            else {
              cut_price = cut_price[keyval];
            }
          });

          if(diamondprice != cut_price) {
            cut_price = diamondprice - cut_price;
            if(cut_price > 0) {
              cut_price_text = '-' + currencysymbol + '' + cut_price.toFixed(2);
            }
            else {
              cut_price = Math.abs(cut_price);
              cut_price_text = '+' + currencysymbol + '' + cut_price.toFixed(2);
            }
          }
          $( obj ).text(cut_price_text);
        });

        $("#" + diamond_type + "nonfeedcolourSlider  .ui-slider-label" ).each(function( index,obj ) {
          var colour = $( obj ).data('colour');
          if(colour == undefined || colour == '') {
            var colour = $.trim( $( obj ).text() );
            $(obj).attr('data-colour', colour);
          }

          var colour_price = 0;
          var colour_price_text = '';
          var keyval = '';
          $.each(filter_keys, function(index, keyname) {
            if(keyname == 'colour') {
              keyval = colour;
            }
            else {
              keyval = productOptions[keyname];
            }

            if(colour_price == 0) {
              colour_price = nonfeedpricecalc[productOptions['diamond_type']][keyval];
            }
            else {
              colour_price = colour_price[keyval];
            }
          });

          if(diamondprice != colour_price) {
            colour_price = diamondprice - colour_price;
            if(colour_price > 0) {
              colour_price_text = '-' + currencysymbol + '' + colour_price.toFixed(2);
            }
            else {
              colour_price = Math.abs(colour_price);
              colour_price_text = '+' + currencysymbol + '' + colour_price.toFixed(2);
            }
          }
          $('.colour-price-'+colour).remove();
          if(colour_price_text != '') {
            $(obj).after('<span class="colour_estimated_price colour-price-'+colour+'">'+colour_price_text+'</span>');
          }
        });
        
        var total_price = metalprice + diamondprice;
        price_markup_val = (price_markup_type == 'percent' && price_markup_val > 0) ? total_price  * price_markup_val / 100 : price_markup_val;
        
        if(price_markup_sign != '' && price_markup_val > 0) {
          total_price = eval(total_price + price_markup_sign + price_markup_val);
        }
        var plain_price = total_price;
        var high_street_price = $widget.getHighStreetPrice(total_price);
        you_save = currencysymbol + '' + (high_street_price - total_price).toFixed(2);
        
        if(discount['is_discount'] == 1) {
          if (discount['discount_percent'] > 0) {
              display_final_discounted_price = total_price - ((total_price * discount['discount_percent']) / 100);
          } else if (discount['discount_amount'] > 0) {
              display_final_discounted_price = total_price - discount['discount_amount'];
          }
          else {
            display_final_discounted_price = total_price
          }

          if(display_final_discounted_price > 0){
              you_save = high_street_price - display_final_discounted_price;
              you_save = currencysymbol + '' + you_save.toFixed(2);
              plain_price = display_final_discounted_price;
              display_final_discounted_price = currencysymbol + '' + display_final_discounted_price.toFixed(2);
          }
        }
        productOptions['high_street_price'] = currencysymbol + '' + high_street_price.toFixed(2);
        productOptions['display_final_discounted_price'] = display_final_discounted_price;
        productOptions['you_save'] = you_save;
        productOptions['is_discount'] = discount['is_discount'];
        productOptions['description'] = discount['description'];
        productOptions['display_price'] = currencysymbol + '' + total_price.toFixed(2);
        productOptions['plain_price'] = plain_price;
        productOptions['metal_short_label'] = (metalShortName[productOptions['metal']] != undefined) ? metalShortName[productOptions['metal']] : productOptions['metal'];
        productOptions['chain_short_label'] = (chainShortName[productOptions['chain']] != undefined) ? chainShortName[productOptions['chain']] : productOptions['chain'];
        $widget.reloadSummary(productOptions);
      }
      else {
        var productpreviewapi = $widget.options.productpreviewapi;
        /*******Abort a previous running Ajax request *******/
        var preview_xhr_tmp = "";
        if (
          $widget.options.preview_xhr !== "undefined" &&
          $widget.options.preview_xhr !== ""
        ) {
          preview_xhr_tmp = $widget.options.preview_xhr;
        }
        /****************************************************/

        var data = $widget.getProductOptions();

        data = $.extend(true, data, $widget.getProductDiamondValues());

        $widget.options.preview_xhr = jQuery.ajax({
          type: "POST",
          url: productpreviewapi,
          data: data,
          dataType: "json",
          success: function (data) {
            if (data.result == "success") {
              $widget.reloadSummary(data.data);
            } else {
              $(".cart-form-error").html(data.message);
              $("#product-addtocart-button").attr("disabled", true);
            }
            $("#dh_loading").hide();
          },
          failure: function (errMsg) {
            console.log(errMsg);
          },
        });

        if (preview_xhr_tmp !== "undefined" && preview_xhr_tmp !== "") {
          preview_xhr_tmp.abort();
        }
      }
    },
    reloadSummary: function (data) {
      var $widget = this;
      $(".cart-form-error").html("");
      $("#product_preview").css("opacity", "1");
      $widget.renderProductPreview(data);
      $("#product_total").val(data.plain_price);
      $("#product-addtocart-button").attr("disabled", false);
      $widget.options.financeobj.loadFinance();
    },
    getHighStreetPrice: function (settingPrice) {
      var $widget = this;
      var highStreetMatrix = $widget.options.highStreetMatrix;
      var highStreetPrice = settingPrice;
      if(settingPrice < 1000) {
          highStreetPrice = highStreetPrice * highStreetMatrix['1000'];
      }
      else if(settingPrice >= 1000 && settingPrice < 2000) {
          highStreetPrice = highStreetPrice * highStreetMatrix['2000'];
      }
      else if(settingPrice >= 2000 && settingPrice < 3000) {
          highStreetPrice = highStreetPrice * highStreetMatrix['3000'];
      }
      else if(settingPrice >= 3000 && settingPrice < 4000) {
          highStreetPrice = highStreetPrice * highStreetMatrix['4000'];
      }
      else {
          highStreetPrice = highStreetPrice * highStreetMatrix['4001'];
      }
      return highStreetPrice;
    },
    getProductOptions: function () {
      var $widget = this;
      var productOptions;
      var diamond_type = $(".nonfeed_diamond_type:checked").val();
      var product_id = $("input[name=product]").val();
      var simple_product_id = $(
        "input[name=selected_configurable_option]"
      ).val();
      var ring_size = "";
      var chain = "";
      var chain_type = "";
      var bracelet_length = "";
      var attributesetname = $widget.options.attributesetname;
      if (attributesetname == "Non Feed Rings") {
        ring_size = $(".custom-ringsize input[type='radio']:checked").val();
      } else if (attributesetname == "Non Feed Pendants") {
        chain = $(".custom-chain input[type='radio']:checked").val();
        chain_type = 1;
      } else if (attributesetname == "Non Feed Bracelets") {
        bracelet_length = $(".custom-length input[type='radio']:checked").val();
      }

      var metal_type_option = $(".metal_type_option:checked").val();
      if (simple_product_id == "") {
        simple_product_id = option_product[metal_type_option];
      }

      productOptions = {
        product_id: product_id,
        simple_product_id: simple_product_id,
        diamond_type: diamond_type,
        ring_size: ring_size,
        chain: chain,
        chain_type: chain_type,
        bracelet_length: bracelet_length,
        attributesetname: attributesetname,
      };
      return productOptions;
    },
    renderProductPreview: function (data) {
      
      var templateId = "template-productpreview";
      var source = document.getElementById(templateId).innerHTML;
      var template = Handlebars.compile(source);
      var html = template(data);
      $("#product_preview").html(html);
      
      if($('#mobile-productpreview').length > 0) {
        var templateId = "template-productpreviewmobile";
        var source = document.getElementById(templateId).innerHTML;
        var template = Handlebars.compile(source);
        var html = template(data);
        $("#mobile-productpreview").html(html);
      }

      var templateId = "template-delivery";
      var source = document.getElementById(templateId).innerHTML;
      var template = Handlebars.compile(source);
      var html = template(data);
      $(".delivery-info").html(html);
    },
    _checkOptionAvailability: function (carat) {
      var $widget = this;
      var diamondType = $(".nonfeed_diamond_type:checked").val();

      if (carat == undefined || carat == "") {
        carat = $("." + diamondType + "nonfeedcaratVal").val();
      }
      var certificate = $(
        "input[name='" + diamondType + "certificate']:checked"
      ).val();
      $("." + diamondType + "-wrap .cert-form-error").html("");
      $("#product-addtocart-button").prop("disabled", false);

      var required_options = $widget.options.required_options;
      if (required_options.lab != false) {
        $('input:radio[name="' + diamondType + 'certificate"]').each(
          function () {
            var cert = $(this).val();
            if (cert == "GIA") {
              var cert_options = required_options.lab.gia;
              var cert_status = cert_options[carat];
              if (cert_status == "invalid") {
                $(this).attr("disabled", true);
              } else {
                $(this).attr("disabled", false);
              }
              var idVal = $(this).attr("id");
              $("label[for='" + idVal + "']")
                .removeClass("valid invalid")
                .addClass(cert_status);
            } else if (cert == "IGI") {
              var cert_options = required_options.lab.igi;
              var cert_status = cert_options[carat];
              if (cert_status == "invalid") {
                $(this).attr("disabled", true);
              } else {
                $(this).attr("disabled", false);
              }
              $("label[for='" + idVal + "']")
                .removeClass("valid invalid")
                .addClass(cert_status);
            }
          }
        );

        var cert_options = false;
        var cert_status = "valid";

        if (certificate == "GIA") {
          var cert_options = required_options.lab.gia;
          var cert_status = cert_options[carat];
          $("." + diamondType + " .gia")
            .removeClass("valid invalid")
            .addClass(cert_status);
        }

        if (certificate == "IGI") {
          var cert_options = required_options.lab.igi;
          var cert_status = cert_options[carat];
          $("." + diamondType + " .igi")
            .removeClass("valid invalid")
            .addClass(cert_status);
        }

        if (cert_status == "invalid") {
          $("." + diamondType + "-wrap .cert-form-error").html(
            "This diamond combination is unavailable in the selected certificate."
          );
          $("#product-addtocart-button").prop("disabled", true);
        } else {
          $("#product-addtocart-button").prop("disabled", false);
          $("." + diamondType + "-wrap .cert-form-error").html("");
        }
      }
    },
    handlebarsHelper: function () {
      Handlebars.registerHelper(
        "calculateDisplayPrice",
        function (price, discountPercent, discountAmount) {
          let calculatedPrice;
          if (discountPercent > 0) {
            calculatedPrice = price - (price * discountPercent) / 100;
          } else if (discountAmount > 0) {
            calculatedPrice = price - discountAmount;
          } else {
            calculatedPrice = price;
          }

          // round to 2 decimal places
          return calculatedPrice.toFixed(2);
        }
      );
    },
  });
  return $.cubix.diamondfeed;
});

